import * as React from "react";

const ShoppingCart: React.FC = () => {
    return (
        <svg
            focusable="false"
            xmlns="http://www.w3.org/2000/svg"
            width="30"
            height="31"
            viewBox="0 0 30 31"
            fill="currentColor"
            fillRule="nonzero"
            stroke="none"
        >
            <path d="M.75 4.358c-.45 0-.75-.296-.75-.74 0-.445.3-.74.75-.74h2.322c1.573 0 2.847 1.11 3.147 2.664l.225 1.11h22.703c.524-.073.974.37.824.889L26.899 18.72c-.075.37-.375.592-.75.592H8.693l.374 2.295H26.15c.45 0 .749.296.749.74 0 .37-.3.74-.75.74H8.468c-.375 0-.675-.296-.75-.592L4.72 5.765c-.15-.815-.824-1.407-1.648-1.407H.749zM10.03 24.2c.965 0 1.781.807 1.781 1.761 0 .955-.816 1.762-1.78 1.762-.966 0-1.782-.807-1.782-1.762 0-.954.816-1.761 1.781-1.761zm13.837 0c.986 0 1.82.807 1.82 1.761 0 .955-.834 1.762-1.82 1.762a1.75 1.75 0 0 1-1.743-1.762 1.75 1.75 0 0 1 1.743-1.761z" />
        </svg>
    );
};

export default React.memo(ShoppingCart);
